import Select from "react-select";
import {
  FieldLabel,
  descriptionSelectStyles,
} from "../../../../../components/propertyDescription/descriptionUi";
import { Wrapper } from "./styles";

interface IOption {
  label: string;
  value: number;
}
interface IProps {
  label: string;
  options: IOption[];
  value?: number;
  onChange: (option: IOption | null) => void;
}

function PropertyAccommodation(props: IProps) {
  const selected =
    props.value != null
      ? props.options.find((option) => option.value === props.value) ?? null
      : null;

  return (
    <Wrapper>
      <FieldLabel>{props.label}</FieldLabel>
      <Select
        placeholder="Número"
        options={props.options}
        value={selected}
        onChange={props.onChange}
        styles={descriptionSelectStyles}
      />
    </Wrapper>
  );
}

export default PropertyAccommodation;
